import React, { useState, useEffect } from 'react'
import { Field } from 'formik'
import { LinearProgress, TextField, Select, MenuItem, InputLabel, FormControl, FormHelperText, Button } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useSelector } from 'react-redux'
import { myBucket } from '../services/UploadService'
import axios from 'axios'
import { ApiURL } from '../constants/ApiUrl'

function FormPageStudent2({ errors, touched, setFieldValue, values, appId }) {
    const qual = useSelector(state => state.FormDataReducer.qual)
    const [DocStatus, setDocStatus] = useState('');
    const [QualState, setQualState] = useState('')
    const [Progress3, setProgress3] = useState(0)
    const [stateList, setStateList] = useState([]);
    const [collegeList, setCollegeList] = useState([])
    const [SName, setSName] = useState('');
    const [CName, setCName] = useState('');
    const [isTrue, setIsTrue] = useState(true)

    useEffect(() => {
        a();
        if (values.state != "") {
            stateChanged(values.state)
        }
    }, [])
    var s = []
    const a = async () => {
        const result = await axios.get(`${ApiURL}/api/get_states`);
        result.data.forEach(element => {
            s.push(element.state_name)
        });
        setStateList(s)
    }

    useEffect(() => {
        const result2 = JSON.parse(localStorage.getItem("type"))
        setFieldValue("docstatus", result2)
        setSName(values.state);
        setCName(values.college);
    }, [values.state, values.college])

    const stateChanged = async (e) => {
        // console.log(e.target.value, "stattttt")
        setSName(values.state);
        setFieldValue("state", e);
        const result = await axios.post(`${ApiURL}/api/get_medical_college`, {            // addinng API for getting prant
            "state": e
        });
        var college=[]
        const college_list = result.data
        college_list.forEach(element => {
            college.push(element)
        });

        console.log("Result set in state", s)
        setCollegeList(college)


    }

    const collegeChanged = (e) => {
        if (e.target.value === 'other') {
            setIsTrue(false)
        }
        setFieldValue("college", e.target.value);
    }

    const handleQual = (e, val) => {
        e.preventDefault();
        setFieldValue("qualifications", val);
        setQualState(val);
    }

    const handleCC = (e, val) => {
        setQualState(val);
    }
    const handleASClose = (e, val) => {
        if (val !== 'select-option') {
            setFieldValue("qualifications", QualState);
        }
    }
const uploadDoc = async (e) => {
  try {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split(".").pop().toLowerCase();
    if (!["jpg", "jpeg", "bmp", "png", "pdf"].includes(ext)) {
      alert("Only JPG, BMP, PNG & PDF files allowed");
      return;
    }

    const params = {
      Bucket: process.env.REACT_APP_Bucket,
      Key: `applications/${appId}/cert_image.${ext}`,
      ContentType: file.type,
    };

    // 1️⃣ Get signed URL from backend
    const res = await axios.get(
      ApiURL +
        `/api/upload/signed-url?key=${encodeURIComponent(
          params.Key
        )}&contentType=${encodeURIComponent(file.type)}`
    );
    const { url } = res.data;
    console.log("Signed URL generated: ", url);

    // 2️⃣ Upload with progress using XMLHttpRequest
    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", url);

      xhr.setRequestHeader("Content-Type", file.type);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          setProgress3(percent);
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(xhr.response);
        } else {
          reject(new Error(`Upload failed with status ${xhr.status}`));
        }
      };

      xhr.onerror = () => reject(new Error("Upload failed due to network error"));
      xhr.send(file);
    });

    // 3️⃣ Update form field with public R2 URL
    setFieldValue(
      "cert_image",
      `https://pub-5e98b3129b274a77aa3ee9286a182644.r2.dev/${params.Key}`
    );

    console.log("File uploaded successfully: ", params.Key);
  } catch (e) {
    console.error("Upload error:", e);
  }
};


    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="norFlexCon">
                {
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <div className="ctrl">
                            <FormControl fullWidth error={touched.qualifications && errors.qualifications}>
                                <Autocomplete freeSolo={true} options={qual} value={values.qualifications} onChange={handleQual} onInputChange={handleCC} onClose={handleASClose}
                                    renderInput={(params) => <TextField {...params} label="Highest Medical Degree*" variant="outlined" />}
                                />
                                <FormHelperText error>{touched.qualifications && errors.qualifications}</FormHelperText>
                            </FormControl>
                        </div>
                        <div className="ctrl">
                            <FormControl variant="outlined" fullWidth error={touched.degree && errors.degree}>
                                <InputLabel id="degreeLabel">Year Of Education *</InputLabel>
                                <Field name="degree" labelId="degreeLabel" label="Year of education *" as={Select} fullWidth >
                                    <MenuItem value="">Select </MenuItem>
                                    <MenuItem value="1st year">1st Year</MenuItem>
                                    <MenuItem value="2nd year">2nd Year</MenuItem>
                                    <MenuItem value="3rd year">3rd Year</MenuItem>
                                    <MenuItem value="4th year">4th Year</MenuItem>
                                </Field>
                                <FormHelperText error>{touched.degree && errors.degree}</FormHelperText>
                            </FormControl>
                        </div>
                        <div className="ctrl">
                            <FormControl variant="outlined" fullWidth error={touched.state && errors.state}>
                                <InputLabel id="stateLabel">State *</InputLabel>
                                <Field name="state" label="State *" labelId="stateLabel" as={Select} value={SName} variant="outlined" onChange={(e)=>stateChanged(e.target.value)} fullWidth error={touched.state && errors.state} helperText={touched.state && errors.state} >
                                    <MenuItem value=''>Select State</MenuItem>
                                    {
                                        stateList.map((item, index) => {

                                            return <MenuItem key={index} value={item}>{item}</MenuItem>

                                        })
                                    }
                                </Field>
                                <FormHelperText error>{touched.state && errors.state}</FormHelperText>
                            </FormControl>
                        </div>
                        {isTrue ? <div className="ctrl">
                            <FormControl variant="outlined" fullWidth error={touched.college && errors.college}>
                                <InputLabel id="collegeLabel">College *</InputLabel>
                                <Field name="college" label="College *" as={Select} variant="outlined" fullWidth value={CName} onChange={collegeChanged} error={touched.college && errors.college} helperText={touched.college && errors.college}>
                                    <MenuItem value=''>Select College</MenuItem>
                                    {
                                        collegeList.map((item, index) => {
                                            return <MenuItem key={index} value={item}>{item}</MenuItem>
                                        })
                                    }
                                </Field>
                                <FormHelperText error >{touched.college && errors.college}</FormHelperText>
                            </FormControl>
                        </div> : <div className="ctrl">
                            <Field name="college" label={"UG College *"} as={TextField} variant="outlined" fullWidth error={touched.college && errors.college} helperText={touched.college && errors.college} />
                        </div>}

                        <div className="ctrl">
                            <Field name="regno" label={DocStatus === 'doctor' ? "Medical or Dental Council License Number" : "College Registration Number"} as={TextField} variant="outlined" fullWidth error={touched.regno && errors.regno} helperText={touched.regno && errors.regno} />
                        </div>
                        <div className="ctrl">
                            <Button variant="contained" component="label" fullWidth>
                                {DocStatus === 'doctor' ? "Medical or Dental Council License Upload" : "College ID Upload"}
                                <input name="cert_image" type="file" hidden onChange={uploadDoc} />
                                <FormHelperText error>{touched.cert_image && errors.cert_image}</FormHelperText>
                            </Button>
                            {values.cert_image !== '' && <a href={values.cert_image} target="_blank" rel="noreferrer">View Uploaded Document</a>}
                            <LinearProgress variant="determinate" value={Progress3} />
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default FormPageStudent2
